// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"31a04e91339925d3177c","691":"ac418ef3c7d88489f3eb"}[chunkId] + ".js";
};